
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights_test",
      function () {
        return require("private-next-pages/insights_test.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights_test"])
      });
    }
  